import React from 'react';
import { Building2, FolderKanban, PlusSquare, History, Settings, LogOut, Search, Bell, HelpCircle, User } from 'lucide-react';
import { useNavigate, Outlet, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/auth/AuthProvider';
import { Dropdown, MenuProps } from 'antd';

const ClientLayout: React.FC = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const menuItems: MenuProps['items'] = [
        {
            key: 'perfil',
            label: 'Meu Perfil',
            icon: <User className="size-4" />,
            onClick: () => navigate('/dashboard-cliente/perfil'),
        },
        {
            key: 'configuracoes',
            label: 'Configurações',
            icon: <Settings className="size-4" />,
            onClick: () => navigate('/dashboard-cliente/configuracoes'),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Sair',
            icon: <LogOut className="size-4" />,
            danger: true,
            onClick: () => {
                logout();
                navigate('/login');
            },
        },
    ];

    return (
        <div className="relative flex min-h-screen w-full bg-[#f6f7f8] dark:bg-[#101922] font-sans">
            <aside className="flex h-screen w-64 flex-col border-r border-slate-200 bg-[#f6f7f8] dark:border-slate-800 dark:bg-[#101922] fixed flex-shrink-0">
                <div className="flex h-full flex-col justify-between p-4">
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center gap-3 p-2">
                            <div className="bg-[#137fec] flex items-center justify-center rounded-lg size-10 text-white">
                                <Building2 />
                            </div>
                            <div className="flex flex-col">
                                <h1 className="text-slate-900 dark:text-white text-base font-bold leading-normal">Quantto</h1>
                                <p className="text-slate-500 dark:text-slate-400 text-sm font-normal leading-normal">Orçamento</p>
                            </div>
                        </div>
                        <nav className="flex flex-col gap-2 mt-4">
                            <Link to="/dashboard-cliente" className="flex items-center gap-3 rounded-lg px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800">
                                <FolderKanban className="size-5" />
                                <p className="text-sm font-medium leading-normal">Meus Projetos</p>
                            </Link>
                            <Link to="/dashboard-cliente/novo-orcamento" className="flex items-center gap-3 px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800 rounded-lg">
                                <PlusSquare className="size-5" />
                                <p className="text-sm font-medium leading-normal">Novo Orçamento</p>
                            </Link>
                            <Link to="/dashboard-cliente/historico" className="flex items-center gap-3 px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800 rounded-lg">
                                <History className="size-5" />
                                <p className="text-sm font-medium leading-normal">Histórico</p>
                            </Link>
                            <Link to="/dashboard-cliente/configuracoes" className="flex items-center gap-3 px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800 rounded-lg">
                                <Settings className="size-5" />
                                <p className="text-sm font-medium leading-normal">Configurações</p>
                            </Link>
                        </nav>
                    </div>
                    <div className="flex flex-col gap-1 border-t border-slate-200 dark:border-slate-800 pt-4">
                        <Dropdown menu={{ items: menuItems }} placement="topRight" arrow>
                            <div className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800 cursor-pointer">
                                <div className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-8" style={{ backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuC4oHEOnJmCEpDlqiT2aYy9wOBAsQeKfhBuPTu544coQ4jPL_nTAC8dXC-UteFqK4-B5J4-38dIhrC8tH5qPNJ5MjGVbj2DPK7__TMQxx5FaTQTVAxAGcTLfLaHh9VJilKXSwFZHfMu0-VgCVtjDiIFFnCSxpsbNZFP4zzdeD0mqgd63-nGK7c9ke2Pjgtdd1tNt3fxQaVavaT_e0r8NGR8ASnUlAS9a7L2u-v4q111VLoxwvRmUYtv1tIyNUBD_Eir74L_tFWpffc")' }}></div>
                                <p className="text-sm font-medium leading-normal">Meu Perfil</p>
                            </div>
                        </Dropdown>
                        <Link to="/dashboard-cliente/ajuda" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                            <HelpCircle className="size-5" />
                            <p className="text-sm font-medium leading-normal">Ajuda</p>
                        </Link>
                        <button onClick={() => { logout(); navigate('/login'); }} className="flex w-full items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 text-[#6B7280] dark:text-[#9CA3AF] hover:text-[#374151] dark:hover:text-[#E5E7EB]">
                            <LogOut className="size-5" />
                            <p className="text-sm font-medium leading-normal">Logout</p>
                        </button>
                    </div>
                </div>
            </aside>
            <main className="ml-64 flex flex-1 flex-col">
                <header className="sticky top-0 z-10 flex h-16 items-center justify-between border-b border-slate-200 bg-[#f6f7f8]/80 px-8 backdrop-blur-sm dark:border-slate-800 dark:bg-[#101922]/80">
                    <div className="w-full max-w-lg">
                        <label className="flex flex-col h-10 w-full">
                            <div className="flex w-full flex-1 items-stretch rounded-lg h-full">
                                <div className="text-slate-400 flex items-center justify-center pl-3">
                                    <Search className="size-5" />
                                </div>
                                <input className="flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-slate-900 focus:outline-0 focus:ring-0 border-none bg-transparent focus:border-none h-full placeholder:text-slate-400 px-2 text-sm font-normal leading-normal" placeholder="Buscar projetos, orçamentos..." />
                            </div>
                        </label>
                    </div>
                    <div className="flex items-center gap-4">
                        <button className="flex items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800 size-10">
                            <Bell className="size-5" />
                        </button>
                        <Link to="/dashboard-cliente/novo-orcamento" className="flex min-w-[84px] cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg h-10 px-4 bg-[#137fec] text-white text-sm font-bold leading-normal tracking-[-0.01em] hover:bg-[#137fec]/90 transition-colors">
                            <PlusSquare className="size-5" />
                            <span className="truncate">Novo Orçamento</span>
                        </Link>
                    </div>
                </header>
                <div className="flex-1 p-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default ClientLayout;
